'use strict';

import $ from 'jquery';
import 'slick-carousel';

export default class GalleryWidget {
	constructor($selector, isFull) {
    this.$imageGalleryImage = $('.image-gallery__images', $selector);
		this.$imageGalleryNav = $('.image-gallery__nav', $selector);

		// set desktop nav size
		const navSlideToShow = $($selector).parents('.col-2__section').length > 0 ? 7 : 11;

		const galleryID = this.$imageGalleryImage.attr('id');
		const navID = this.$imageGalleryNav.attr('id');

		this.$imageGalleryImage.on('init reInit', (event, slick, currentSlide, nextSlide) => {
			onPrint($selector);
			$selector.find('.image-gallery__indicator').text(`${(currentSlide ? currentSlide : 0) + 1} / ${slick.slideCount}`);
		});

		this.$imageGalleryImage.on('afterChange', function (event, slick, currentSlide, nextSlide) {
			$selector.find('.image-gallery__indicator').text(`${(currentSlide ? currentSlide : 0) + 1} / ${slick.slideCount}`);
		});

		let imageOptions = null;
		let navOptions = null;

		if (isFull) {
			imageOptions = {
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: true,
				asNavFor: `#${navID}`,
				prevArrow: '<button type="button" class="slick-prev prev"><i class="icon-arrow-left"></i></button>',
				nextArrow: '<button type="button" class="slick-next next"><i class="icon-arrow-right"></i></button>'
			}

			navOptions = {
				slidesToShow: navSlideToShow,
				slidesToScroll: 1,
				asNavFor: `#${galleryID}`,
				arrows: false,
				dots: false,
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 7
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 5,
						}
					},
					{
						breakpoint: 540,
						settings: {
							slidesToShow: 3,
						}
					}
				]
			}
		}
		else {
			imageOptions = {
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: true,
				asNavFor: `#${navID}`,
				prevArrow: '<button type="button" class="slick-prev prev"><i class="icon-arrow-left"></i></button>',
				nextArrow: '<button type="button" class="slick-next next"><i class="icon-arrow-right"></i></button>'
			}

			navOptions = {
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: `#${galleryID}`,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 3,
              centerPadding: "38px"
            }
          },
          {
            breakpoint: 540,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: "113px"
            }
          }
        ]
      };
		}


		this.$imageGalleryImage.slick(imageOptions);
		this.$imageGalleryNav.slick(navOptions);

		function onPrint($gallery){
			let beforePrint = function () {
				console.log('Functionality to run before printing.');
				$('.image-gallery__images', $gallery).slick('setPosition');
				$('.image-gallery__nav', $gallery).slick('setPosition');
			};

			let afterPrint = function () {
				console.log('Functionality to run after printing');
				$('.image-gallery__images', $gallery).slick('setPosition');
				$('.image-gallery__nav', $gallery).slick('setPosition');
			};

			if (window.matchgallery) {
				let galleryQueryList = window.matchgallery('print');

				galleryQueryList.addListener(function (mql) {
					if (mql.matches) {
						beforePrint();
					} else {
						afterPrint();
					}
				});
			}

			window.onbeforeprint = beforePrint;
			window.onafterprint = afterPrint;
		}
	}
}
